import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from '../../../config/store';
import {serverAPIUrl} from "../../../services/api";


export interface FormMailProp {
    id?: number
    branch: number
    name?: string
    phone?: string
    email?: string
    text?: string
    tp?: number,
}

export const saveFormMail = createAsyncThunk(
    'service/order-mail',
    async (data: FormMailProp, thunkAPI) => {
        const state = thunkAPI.getState() as RootState;
        try {
            const response = await fetch(`${serverAPIUrl}service/order-mail/`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            })

            const responseData = await response.json();

            if (response.status != 201) {
                return thunkAPI.rejectWithValue(responseData)
            } else {
                return thunkAPI.fulfillWithValue(responseData)
            }
        } catch (err) {
            return thunkAPI.rejectWithValue({serverError: err.toString()})
        }
    }
)

interface InitialState {
    data: any;
    error: any
}

const initialState: InitialState = {
    data: {
        id: null,
        name: '',
    },
    error: [],
}

export const formMailSlice = createSlice({
    name: 'formmail',
    initialState: initialState,
    reducers: {
        resetMailForm: (state: any) => {
            state.data = initialState;
            state.error = []
        },
    },
    extraReducers: (builder) => {
        builder.addCase(saveFormMail.fulfilled, (state: any, action: any) => {
            state.data = action.payload;
            state.error = []
        }).addCase(saveFormMail.rejected, (state: any, action: any) => {
            state.error = action.payload;
        })
    },
});

export const {
    resetMailForm
} = formMailSlice.actions;

export const selectFormMail = (state: RootState) => state.formmail;

export default formMailSlice.reducer;